import styled from 'styled-components';

export const ContainerModal = styled.div`
  background: #ffffff;
  border-radius: 16px 0 16px 16px;
  padding: 16px;
  width: 600px;
`;
